var _rect, _path, _rect2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircle96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(40 40) rotate(-180)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 5.00001C28.2714 5.00001 35.0002 11.7288 35.0002 20C35.0002 28.2713 28.2714 35 20.0002 35C11.7289 35 5.00016 28.2713 5.00017 20C5.00017 11.7288 11.7289 5.00001 20.0002 5.00001ZM20.0002 35.8333C28.7306 35.8333 35.8335 28.7304 35.8335 20C35.8335 11.2696 28.7306 4.16668 20.0002 4.16668C11.2697 4.16668 4.16683 11.2696 4.16683 20C4.16683 28.7304 11.2697 35.8333 20.0002 35.8333Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.833332,
    height: 15.8333,
    transform: "translate(20.417 27.9167) rotate(-180)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.417 27.0834L19.5837 27.0834L19.5837 27.9167L20.417 27.9167L20.417 27.0834Z",
    fill: "#009FDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.417 12.0834L19.5837 12.0834L19.5837 25L20.417 25L20.417 12.0834Z",
    fill: "#009FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle96);
export default __webpack_public_path__ + "static/media/information-circle_96.13aebb9db1bf0b5435a018034fa73ea2.svg";
export { ForwardRef as ReactComponent };